export default __webpack_public_path__ + "static/media/calendar.bbd169d8.svg";